
/**
 * @file 侧导航折叠按钮
 * @author sunyingying01
 */

import React from 'react';
import {observer} from 'mobx-react-lite';
import CollapsedBtnSvg from '@assets/icons/collapsedBtn.svg';
import OpenSvg from '@assets/icons/openBtn.svg';
import cx from 'classnames';
import {Tooltip} from 'antd';
import {SiderNavigationStore} from '@/stores';
import styles from './index.module.less';

interface CollapsedBtnProps {
    store: SiderNavigationStore;
    className?: string;
}

const CollapsedBtn: React.FC<CollapsedBtnProps> = props => (
    <div
        className={cx(styles.toggleButton, props.className)}
        onClick={props.store.toggleCollapsed}
    >
        {props.store.collapsed ? (
            <Tooltip trigger={['hover', 'click']} title="展开侧边栏" placement="right"><OpenSvg /></Tooltip>
        ) : (
            <Tooltip trigger={['hover', 'click']} title="收起侧边栏" placement="right">
                <CollapsedBtnSvg />
            </Tooltip>
        )}
    </div>
);


export default observer(CollapsedBtn);
